import React, { Component } from "react";
import { ChangeTitle } from "../util/ChangeTitle";
import "./about.css"
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
export default class About extends Component {
  componentDidMount() {
    document.title = 'About';
  }
  render() {
    ChangeTitle("About ");
    return (
      <section id="about" class="about section-bg">
        <div class="container-fluid" data-aos="fade-up">
          <div class="row no-gutters">
            <div class="content col-xl-12 col-lg-12 d-flex align-items-center">
              <div class="content">
              <h1 class="logo me-auto" className="about-li">
                  <Link className="about-link" to="/">About: financeFrenzy</Link>
                </h1>

                <p align="justify">
                  Finance Frenzy is an independent financial services company
                  that offers vast array of investment, retirement and estate
                  planning products through a network of independent affiliates.
                  No matter what financial challenges clients may face, Finance
                  Frenzy has the experience and resources to create a successful
                  financial plan. Our experienced licensed professional help our
                  clients to complete a financial analysis, identify the
                  financial gap, and offer appropriate investment vehicles to
                  fill this gap. With all the unprecedented financial times, it
                  is important to help clients preserve their capital, while
                  seeking long-term growth and appreciation. Our associates are
                  among the most educated and well-trained in the industry.
                </p>
                {/* <div class="container-fluid" data-aos="fade-up">
                  <div class="section-title">
                    <p>
                      <h1 align="left" className="mt-3">
                      Neelima Devineni
                      </h1>{" "}
                      <p align="left">Chair woman, Founder</p>

                      <h1 align="left" className="mt-3">
                      Selvavel Shanmugam
                  
                      </h1>{" "}
                      <p align="left">CEO, Co-Founder</p>
 
                    </p>

                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>

      </section>
    );
  }
}
